export enum MemberTableStates {
  INITIAL = "initial",
  ASSIGN = "assign",
  ADD = "add",
  EDIT = "edit",
  END = "end",
}
export enum AllocationModel {
  UNLIMITED = "Unlimited",
  LIMITED = "Limited",
}

export type AllocationModelType =
  | AllocationModel.UNLIMITED
  | AllocationModel.LIMITED;

export enum FundraiseTabs {
  CREATE_FUNDRAISE,
  IMPORT_FUNDRAISE,
}
